module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "CommissionDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CommissionDetailView!./src/pages/Promote/Achievement/Commission/Detail/DetailView.js
// module id = 2089
// module chunks = 367